// extracted by mini-css-extract-plugin
export default {"form":"styles_form__Nvgiz","container":"styles_container__Q785z","submit":"styles_submit__K91bp","buttonWrapper":"styles_buttonWrapper__Q2EqN"};